export default "__VITE_ASSET__BaX_dAyC__"